// extracted by mini-css-extract-plugin
export default {"ContentManagement":"styles_ContentManagement__Kdd4l","container":"styles_container__kGtDd"};